import React, { useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { useDispatch } from 'react-redux'; 
import { signIn } from '../../../slices/authSlice';
import { login } from '../../../api/auth';  
import localStorage from "redux-persist/lib/storage";

const Signin = () => {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const route = all_routes;
  const dispatch = useDispatch();
  const navigate = useNavigate(); 

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  const handleLogin = async () => {
    setLoading(true);
    setError(''); // Réinitialiser l'erreur avant de tenter la connexion
  
    // Validation des champs email et password
    if (!email || !password) {
      setError('Veuillez remplir tous les champs.');
      setLoading(false);
      return;
    }
  
    // Validation de la structure de l'email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Veuillez saisir une adresse e-mail valide.');
      setLoading(false);
      return;
    }
  
    // Validation de la longueur du mot de passe
    if (password.length < 6) {
      setError('Le mot de passe doit contenir au moins 6 caractères.');
      setLoading(false);
      return;
    }
  
    try {
      const response = await login(email, password);
  
      // Stockage des informations utilisateur et du token dans le localStorage
      localStorage.setItem('authToken', response.token);
      localStorage.setItem('user', JSON.stringify(response.user));
  
      // Dispatch l'action signIn pour mettre à jour le store Redux
      dispatch(signIn({ user: response.user, token: response.token }));
  
      // Redirection vers la page après connexion
      navigate(route.allmodule);
    } catch (err) {
      // Gestion des erreurs
      // console.log(err);
      setError(err.message || 'Erreur lors de la connexion');
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper bg-img">
          <div className="login-content">
            <form action="index">
              <div className="login-userset">
                <div className="login-logo logo-normal">
                  <ImageWithBasePath src="assets/img/logo.png" alt="img" />
                </div>
               
                <div className="login-userheading">
                  <h3 className="text-center">Connexion</h3>
                  <h4>
                    Accédez à l&apos;espace de gestion en utilisant votre e-mail et votre mot de passe.
                  </h4>
                </div>

                {/* Formulaire d'email */}
                <div className="form-login mb-3">
                  <div className="form-addons">
                    <input 
                      type="email" 
                      className="form-control" 
                      placeholder="Entrez votre Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      
                    />
                    <ImageWithBasePath
                      src="assets/img/icons/mail.svg"
                      alt="img"
                    />
                  </div>
                </div>

                {/* Formulaire de mot de passe */}
                <div className="form-login mb-3">
                  <div className="pass-group">
                    <input
                      type={isPasswordVisible ? "text" : "password"}
                      className="pass-input form-control"
                      placeholder="Entrez votre mot de passe"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span
                      className={`fas toggle-password ${isPasswordVisible ? "fa-eye" : "fa-eye-slash"}`}
                      onClick={togglePasswordVisibility}
                    ></span>
                  </div>
                </div>

                
                {/* Case "Se souvenir de moi" */}
                <div className="form-login authentication-check">
                  <div className="row">
                    <div className="col-12 d-flex align-items-center justify-content-between">
                      <div className="custom-control custom-checkbox">
                        <label className="checkboxs ps-4 mb-0 pb-0 line-height-1">
                          <input type="checkbox" className="form-control" />
                          <span className="checkmarks" />
                          Se souvenir de moi
                        </label>
                      </div>
                      <div className="text-end">
                        <Link className="forgot-link" to={route.forgotPassword}>
                          {/* Mot de passe oublié ? */}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Affichage des erreurs */}
                {error && <div className="text-red text-center">{error}</div>}

                {/* Bouton de connexion */}
                <div className="form-login">
                  <button 
                    type="button" 
                    className="btn btn-login" 
                    onClick={handleLogin} 
                    disabled={loading}
                  >
                    {loading ? "Chargement..." : "Se connecter"}
                  </button>
                </div>

                {/* Footer */}
                <div className="form-sociallink">
                  <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                    <p>Copyright © 2025 <Link to={'https://harnix.bj/'} className="forgot-link">Harnix SAS</Link>. All rights reserved</p>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
